import axios from "axios";

// When REACT_APP_BACKEND_URL is unset/empty (production build behind the reverse proxy),
// fall back to "" so API_BASE is the relative "/api" on the same origin. In local dev it's
// set to http://localhost:8001. This keeps the build host-agnostic (LAN IP, Tailscale name, etc.).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach token from localStorage as fallback (cookie is primary)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jt_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// A stable idempotency key for one prepared money action. Generate once when a modal
// opens and reuse it across retries so a double-click / network retry can't double-post.
export function newIdempotencyKey() {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  } catch { /* ignore */ }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  }
  // Object detail (e.g. structured 409 from /bl/finalize): prefer .message > .error > stringified JSON
  if (typeof detail === "object") {
    return detail.message || detail.error || JSON.stringify(detail);
  }
  return String(detail);
}
